import Enum from '/@/modules/core/app/helpers/Enum';
import EstateTypeLang from '/@/modules/estate/services/EstateTypeLang';
import Lang from '/@/modules/core/app/services/Lang';

export class AssetShareOwnershipType extends Enum {
  key!: string;
  value!: string;
  title!: string;
  description!: string;

  static SOLE: AssetShareOwnershipType = {
    key: 'sole',
    get value() {
      return Lang.t('asset.sole-ownership');
    },
    get title() {
      return Lang.t('accounting.sole-ownership-title');
    },
    get description() {
      return EstateTypeLang.assetShareOwnershipSoleDescription;
    }
  };

  static JOINT: AssetShareOwnershipType = {
    key: 'joint',
    get value() {
      return Lang.t('asset.joint');
    },
    get title() {
      return Lang.t('accounting.joint-ownership-title');
    },
    get description() {
      return EstateTypeLang.assetShareOwnershipJointDescription;
    }
  };

  static JOINT_WITH_SURVIVORSHIP_RIGHT: AssetShareOwnershipType = {
    key: 'joint_with_survivorship_right',
    get value() {
      return Lang.t('asset.joint-of-survivorship');
    },
    get title() {
      return Lang.t('accounting.joint-of-survivorship-title');
    },
    get description() {
      return Lang.t('asset.automatically-to-co');
    }
  };
}
